import { CommonModule } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
@Component({
  selector: 'ddc-privacy',
  templateUrl: './ddc-privacy.component.html',
  styleUrl: './ddc-privacy.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcPrivacyComponent implements OnInit {
  @Input('code') _code: string
  @Input('withText') _withText: boolean = true

  constructor(private logger: DdcLoggerService) {}

  ngOnInit(): void {}
}
